import React, { useEffect, useMemo, useState } from "react";
import { publicApi } from "@/lib/api";
import { SectionHeading, EventCard, Loader } from "@/components/public/ui";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const CATS = [
  { key: "all", label: "All" },
  { key: "dining", label: "Dining" },
  { key: "live-entertainment", label: "Live Entertainment" },
  { key: "holidays", label: "Holidays" },
  { key: "special-events", label: "Special Events" },
];

export default function Happenings() {
  const [events, setEvents] = useState(null);
  const [properties, setProperties] = useState([]);
  const [cat, setCat] = useState("all");
  const [prop, setProp] = useState("all");

  useEffect(() => {
    publicApi.get("/events").then((r) => setEvents(r.data)).catch(() => setEvents([]));
    publicApi.get("/properties").then((r) => setProperties(r.data)).catch(() => {});
  }, []);

  const filtered = useMemo(() => {
    if (!events) return [];
    return events.filter((e) => (cat === "all" || e.category === cat) && (prop === "all" || e.property_slug === prop));
  }, [events, cat, prop]);

  return (
    <div className="pt-20">
      <section className="bg-[#18344A] py-20 text-white">
        <div className="mx-auto max-w-[1280px] px-5 lg:px-8">
          <SectionHeading eyebrow="What's On" title="Happening Across Pack Brothers" light
            intro="Seasonal dinners, live music, brunches, holidays and celebrations across every destination." />
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-5 py-14 lg:px-8">
        <div className="mb-10 flex flex-col gap-4 sm:flex-row sm:items-center">
          <div className="flex flex-wrap gap-2">
            {CATS.map((c) => (
              <button key={c.key} onClick={() => setCat(c.key)} data-testid={`happenings-cat-${c.key}`}
                className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  cat === c.key ? "bg-[#18344A] text-white" : "border border-[var(--pb-border)] bg-white text-[#526E7E] hover:border-[#526E7E]"
                }`}>
                {c.label}
              </button>
            ))}
          </div>
          <div className="sm:ml-auto">
            <Select value={prop} onValueChange={setProp}>
              <SelectTrigger data-testid="happenings-property-filter" className="h-10 w-[220px] rounded-full border-[var(--pb-border)] bg-white text-sm"><SelectValue placeholder="All properties" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All properties</SelectItem>
                {properties.map((p) => <SelectItem key={p.id} value={p.slug}>{p.name}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>

        {events === null ? <Loader /> : filtered.length === 0 ? (
          <p className="py-20 text-center text-[rgba(48,56,60,0.6)]">No happenings match your filters right now. Check back soon.</p>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">{filtered.map((e) => <EventCard key={e.id} e={e} />)}</div>
        )}
      </section>
    </div>
  );
}
